/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface UpdateItemNoteRequest
 */
export interface UpdateItemNoteRequest {
  /**
   *
   * @type {string}
   * @memberof UpdateItemNoteRequest
   */
  companyListItemId: string;
  /**
   *
   * @type {string}
   * @memberof UpdateItemNoteRequest
   */
  note?: string | null;
}

/**
 * Check if a given object implements the UpdateItemNoteRequest interface.
 */
export function instanceOfUpdateItemNoteRequest(
  value: object,
): value is UpdateItemNoteRequest {
  if (
    !("companyListItemId" in value) ||
    value["companyListItemId"] === undefined
  )
    return false;
  return true;
}

export function UpdateItemNoteRequestFromJSON(
  json: any,
): UpdateItemNoteRequest {
  return UpdateItemNoteRequestFromJSONTyped(json, false);
}

export function UpdateItemNoteRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): UpdateItemNoteRequest {
  if (json == null) {
    return json;
  }
  return {
    companyListItemId: json["companyListItemId"],
    note: json["note"] == null ? undefined : json["note"],
  };
}

export function UpdateItemNoteRequestToJSON(json: any): UpdateItemNoteRequest {
  return UpdateItemNoteRequestToJSONTyped(json, false);
}

export function UpdateItemNoteRequestToJSONTyped(
  value?: UpdateItemNoteRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyListItemId: value["companyListItemId"],
    note: value["note"],
  };
}
